module.exports = __webpack_public_path__ + "media/30th_anniversary_sweepstakes/fastweb-30-years-lockup-c5ea1d08.png";